import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import qs from 'qs';
import { CONFIG_URL } from '../config';
import { sendRequest } from '../helper/utils/request';
/**
 * 获取uuid
 * @param {*} values 设备数据
 * @param {*} _config 用户配置
 */

export var getUuid = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values, _config) {
    var _config$uuidConfig, _config$uuidConfig2, _config$uuidConfig$pr, _config$uuidConfig3;

    var uuid, env, apiHost, protocol, uuidApiPath, res, _res$data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            uuid = '', env = _config === null || _config === void 0 ? void 0 : (_config$uuidConfig = _config.uuidConfig) === null || _config$uuidConfig === void 0 ? void 0 : _config$uuidConfig.env, apiHost = _config === null || _config === void 0 ? void 0 : (_config$uuidConfig2 = _config.uuidConfig) === null || _config$uuidConfig2 === void 0 ? void 0 : _config$uuidConfig2.apiHost;
            protocol = (_config$uuidConfig$pr = _config === null || _config === void 0 ? void 0 : (_config$uuidConfig3 = _config.uuidConfig) === null || _config$uuidConfig3 === void 0 ? void 0 : _config$uuidConfig3.protocol) !== null && _config$uuidConfig$pr !== void 0 ? _config$uuidConfig$pr : 'https://';
            uuidApiPath = '/device_uuid/apply_device_uuid_web';

            if (!(env && apiHost)) {
              _context.next = 13;
              break;
            }

            _context.prev = 4;
            _context.next = 7;
            return sendRequest({
              url: protocol + apiHost + uuidApiPath,
              // process?.env.NODE_ENV === 'development'
              //   ? uuidApiPath
              //   : protocol + apiHost + uuidApiPath,
              headers: {
                env: env,
                handled: 1
              },
              params: values,
              noReturn: false
            });

          case 7:
            res = _context.sent;

            if (res === null || res === void 0 ? void 0 : res.success) {
              uuid = res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.deviceUuid;
            }

            _context.next = 13;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](4);

          case 13:
            return _context.abrupt("return", String(uuid));

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 11]]);
  }));

  return function getUuid(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();